import React, { Component } from 'react';
import { Icon, Modal } from 'semantic-ui-react';
import { Button } from 'formik-semantic-ui';

import { IPtw } from '@relab/alstom-ptw-shared';
import { PtwCreateComponent } from './PtwCreateComponent';
import { TranslationComponent } from '../TranslationComponent';

interface PtwEditModalProps {
  ptw: IPtw;
}

export class PtwEditModal extends Component<PtwEditModalProps> {
  state: { open: boolean } = {
    open: false,
  };

  toggleOpen = (open: boolean) => {
    this.setState({ open });
  };

  render() {
    return (
      <Modal
        open={this.state.open}
        onClose={() => this.toggleOpen(false)}
        trigger={
          <Button
            icon
            onClick={(event: any) => {
              event.stopPropagation();
              this.toggleOpen(true);
            }}
          >
            <Icon name="pencil alternate" />
          </Button>
        }
      >
        <Modal.Header>
          <TranslationComponent stringKey={'Add completion status'} />
        </Modal.Header>
        <Modal.Content>
          <PtwCreateComponent ptw={this.props.ptw} onComplete={() => this.toggleOpen(false)} />
        </Modal.Content>
      </Modal>
    );
  }
}
